export const elixirDefaultSource = `# IO.puts and IO.inspect will be matched by pattern!
# Click diff tab to see rewrite.

defmodule MyApp.UserService do
  def create_user(params) do
    IO.puts("Creating user with params")
    IO.inspect(params, label: "User params")
    
    case validate_params(params) do
      {:ok, valid_params} ->
        IO.puts("Validation successful")
        create_user_record(valid_params)
      
      {:error, reason} ->
        IO.inspect(reason, label: "Validation error")
        {:error, reason}
    end
  end
  
  def process_batch(users) when is_list(users) do
    IO.puts("Processing batch of #{length(users)} users")
    
    users
    |> Enum.map(fn user ->
      IO.inspect(user.id, label: "Processing user")
      process_single_user(user)
    end)
  end
  
  defp validate_params(%{email: email} = params) do
    IO.puts("Validating email: #{email}")
    # validation logic here
    {:ok, params}
  end
end`;

export const elixirDefaultCodemod = `import { type SgRoot } from "@ast-grep/napi";
import type Elixir from "@ast-grep/napi/lang/elixir";

async function transform(root: SgRoot<Elixir>): Promise<string> {
  const rootNode = root.root();

  // Find IO.puts calls
  const ioPutsNodes = rootNode.findAll({
    rule: {
      pattern: "IO.puts($ARG)"
    },
  });

  // Find IO.inspect calls  
  const ioInspectNodes = rootNode.findAll({
    rule: {
      pattern: "IO.inspect($$$ARGS)"
    },
  });

  const edits = [
    ...ioPutsNodes.map(node => {
      const arg = node.getMatch("ARG").text();
      return node.replace(\`Logger.info(\${arg})\`);
    }),
    ...ioInspectNodes.map(node => {
      const args = node.getMultipleMatches("ARGS")
        .map(x => x.text())
        .filter(x => x !== ',')
        .join(', ');
      // For IO.inspect, we'll convert to Logger.debug to preserve the inspection behavior
      return node.replace(\`Logger.debug(\${args})\`);
    })
  ];

  const newSource = rootNode.commitEdits(edits);
  return newSource;
}

export default transform;
`;

export const elixirDefaultConfig = `
# Codemod Studio uses ast-grep to match and rewrite code.
# https://ast-grep.github.io/guide/rule-config.html#rule
id: replace-io-with-logger
language: elixir
rule:
  any:
    - pattern: IO.puts($ARG)
    - pattern: IO.inspect($$$ARGS)
fix: |
  Logger.info($ARG)$ARGS
`.trim();
